import { registerLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import kk from "date-fns/locale/kk";

registerLocale("ru", ru);
registerLocale("kk", kk);

export { ru, kk };